export enum DateFormat {
  DAY_MONTH_YEAR_TIME = 'DD.MM.YYYY, hh:mm:ss',
  DAY_MONTH_YEAR = 'dd.MM.yyyy',
  YEAR_MONTH_DAY = 'YYYYMMdd',
  SDP_CREATION_TIME = 'YYMMDD_HHmmss',
  CSV_EXPORT_FORMAT = 'YYYY-MM-DD_HH-mm',
}
